import { ComingSoon } from "components/commons";

function Live() {
  return (
    <div className="flex-1 flex flex-col justify-center items-center">
      <ComingSoon />
    </div>
  );
}

export { Live as default };
